import { FC, useMemo } from "react";
import { PromptTip } from "./PromptTip";
import { getRandomTips } from "./promptTipsData";

interface PromptTipsProps {
  onTipClick?: (doText: string) => void;
}

export const PromptTips: FC<PromptTipsProps> = ({ onTipClick }) => {
  const tips = useMemo(() => getRandomTips(1), []);

  return (
    <div className="flex flex-col gap-2">
      {tips.map((tip) => (
        <PromptTip
          key={tip.id}
          labelKey={tip.labelKey}
          dontKey={tip.dontKey}
          doKey={tip.doKey}
          onClick={onTipClick}
        />
      ))}
    </div>
  );
};
